var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcCircleClose = function SvgIcCircleClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    fill: "none",
    viewBox: "0 0 26 26"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "#fff",
    d: "M21.839 4.161A12.42 12.42 0 0 0 13 .5C9.662.5 6.521 1.8 4.161 4.161A12.42 12.42 0 0 0 .5 13c0 3.338 1.3 6.479 3.661 8.839A12.42 12.42 0 0 0 13 25.5c3.338 0 6.479-1.3 8.839-3.661A12.42 12.42 0 0 0 25.5 13c0-3.338-1.3-6.479-3.661-8.839Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.193 16.533a1.172 1.172 0 0 1-1.658 1.657l-3.533-3.533-3.533 3.534a1.17 1.17 0 0 1-1.657 0 1.17 1.17 0 0 1 0-1.658L11.345 13 7.812 9.467A1.172 1.172 0 0 1 9.469 7.81l3.533 3.533 3.533-3.533a1.172 1.172 0 1 1 1.657 1.657L14.66 13z"
  })));
};
export default SvgIcCircleClose;